<mat-drawer-container class="expand">
    <div *ngIf="!drawer.opened">
        <button mat-button (click)="drawer.toggle()">
            <mat-icon>keyboard_double_arrow_right</mat-icon>
        </button>
    </div>
    <mat-drawer #drawer [opened]="lockOpened" mode="side" class="hide-scrollbar">
        <div class="fx">
            <span class="expand"></span>
            <button mat-button (click)="drawer.toggle()">
                <mat-icon>keyboard_double_arrow_left</mat-icon>
            </button>
        </div>
        <ng-content></ng-content>
    </mat-drawer>
</mat-drawer-container>
